export default __webpack_public_path__ + "static/media/ctSomethingWentWrong.8e1045b9.png";